import { RESET_STATE } from '../../../wizard/store/wizard.action-types';
import { FULL_NAME_SAVE } from './fullName.action-types';

const INITIAL_STATE = {
  selected: {
    name: null,
    isCompany: false,
  },
};

const fullNameReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...state,
        selected: {
          name: null,
          isCompany: false,
        },
      };
    case FULL_NAME_SAVE:
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
};

export default fullNameReducer;